define(()=> {
    /**
     * Show a cancel confirmation
     */
    return function (ModalComponent, StateUtils) {
        return function (model, {title, message}) {
            title = title || 'platform.flow.angularhelpers.CancelConfirmation.Are you sure you want to cancel?';
            message = message || 'platform.flow.angularhelpers.CancelConfirmation.The information previously entered will be stored as a draft';

            const validModel = (model && model.aspects && model.aspects.valid && model.aspects.subtreeValid) ? model : StateUtils.activeDataForState(true).flowModel.snapshot;
            const cancelConfirmedPromise = ModalComponent.showWarning(title, message).result;

            return cancelConfirmedPromise.then(() => validModel);
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/flow/angularhelpers/CancelConfirmation.js